import { useRouteError } from 'react-router'

import { themePalettes } from 'src/themes'
import { DEFAULT_THEME_TYPE, THEME_TYPES, ThemeType } from 'src/themes/types'
import { THEME_LOCAL_STORAGE_KEY } from 'src/contexts/ThemeContext'

// This component reads theme colors directly from palette definitions and
// localStorage instead of consuming ThemeProvider context. As a route-level
// error boundary, it must render even when providers (including ThemeProvider)
// have crashed — which is exactly when errorElement is activated. Reading the
// persisted theme preference keeps the error page visually consistent with the
// user's last known theme choice.

const getRoutingErrorColors = () => {
    try {
        const stored = JSON.parse(localStorage.getItem(THEME_LOCAL_STORAGE_KEY) || '{}')
        const themeType: ThemeType = THEME_TYPES.includes(stored.themeType) ? stored.themeType : DEFAULT_THEME_TYPE
        const colors = themePalettes[themeType].routingError

        return colors
    } catch {
        // localStorage may be unavailable (e.g. private browsing quota exceeded)
    }

    return themePalettes[DEFAULT_THEME_TYPE].routingError
}

export const RoutingError = () => {
    const routeError = useRouteError()
    if (routeError) {
        console.error('RoutingError boundary caught:', routeError)
    }

    const colors = getRoutingErrorColors()

    const linkStyle: React.CSSProperties = {
        fontSize: '16px',
        color: colors.linkColor,
        lineHeight: 1.5,
        textDecoration: 'underline',
    }

    return (
        <main
            style={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                backgroundColor: colors.backgroundColor,
                color: colors.textColor,
                fontFamily: 'system-ui, -apple-system, sans-serif',
            }}>
            <h1 style={{ fontSize: '32px', lineHeight: 1.5, margin: 0 }}>Something went wrong</h1>
            <span style={{ fontSize: '16px', lineHeight: 1.5 }}>Please try again later or contact support.</span>
            <div style={{ display: 'flex', gap: '16px' }}>
                <a href={window.location.href} style={linkStyle}>
                    Refresh page
                </a>
                <a href="/" style={linkStyle}>
                    Return to home page
                </a>
            </div>
        </main>
    )
}
